/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperatorVcdsComponentNetwork } from './operatorVcdsComponentNetwork';
import { KeyValuePair } from './keyValuePair';
import { VcdsComponentInventoryTree } from './vcdsComponentInventoryTree';
import { OperatorVcdsComponentApplicationAndInfraHealth } from './operatorVcdsComponentApplicationAndInfraHealth';
import { VcdsComponentVersion } from './vcdsComponentVersion';
import { VcdsComponentStats } from './vcdsComponentStats';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface OperatorVcdsDeploymentComponent { 
    /**
     * Component Id
     */
    component_id?: string;
    /**
     * Component name
     */
    name?: string;
    /**
     * Org Id
     */
    org_id?: string;
    /**
     * Deployment Id
     */
    deployment_id?: string;
    /**
     * Component type
     */
    component_type?: string;
    vcds_service_type?: VcdsServiceTypeEnum;
    /**
     * Component creation date time
     */
    created_time?: Date;
    /**
     * Component deletion date time
     */
    deleted_time?: Date;
    health?: OperatorVcdsComponentApplicationAndInfraHealth;
    inventory?: VcdsComponentInventoryTree;
    /**
     * Component last updated date time
     */
    last_updated_time?: Date;
    build_info?: Array<KeyValuePair>;
    metadata?: Array<KeyValuePair>;
    network?: OperatorVcdsComponentNetwork;
    /**
     * Reported by agent type
     */
    reported_by?: string;
    stats?: VcdsComponentStats;
    version?: VcdsComponentVersion;
}
export namespace OperatorVcdsDeploymentComponent {
}


